import type { FieldType } from '@kizen/api';

const types: Record<FieldType | 'wysiwyg', null> = {
  checkbox: null,
  checkboxes: null,
  date: null,
  datetime: null,
  decimal: null,
  dropdown: null,
  dynamictags: null,
  email: null,
  files: null,
  integer: null,
  longtext: null,
  money: null,
  phonenumber: null,
  radio: null,
  rating: null,
  relationship: null,
  status: null,
  team_selector: null,
  text: null,
  timezone: null,
  yesnomaybe: null,
  wysiwyg: null,
};

export const isFieldType = (value: any): value is FieldType => {
  return typeof value === 'string' && value in types;
};
